export const ERRORS_URL = Object.freeze({
  path: '',
  generic: {
    name: 'error.generic',
    path: '/error',
  },
  forbidden: {
    name: 'error.forbidden',
    path: '/forbidden',
  },
});

export const ERRORS_CODES = Object.freeze({
  E_ROUTE_NOT_FOUND: 'Page not found',
});
